/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import IconButton from '@mui/material/IconButton';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { iconStyle } from './style';

function ButtonExport({ data = [], labels = [], headers = [], fileName = 'archivo', sheetName = 'main' }) {
  const saveButton = (
    <IconButton aria-label="delete" size="large">
      <FileUploadIcon fontSize="inherit" style={iconStyle} />
    </IconButton>
  );

  return (
    <></>
    // <ExcelFile element={saveButton} fileName={fileName} onClick>
    //   <ExcelSheet data={data} name={sheetName}>
    //     {headers.map((label, index) => {
    //       const id = index;
    //       return <ExcelColumn key={id} label={label} value={labels[index]} />;
    //     })}
    //   </ExcelSheet>
    // </ExcelFile>
  );
}

export default ButtonExport;
